/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeviceResponse,
    DeviceResponseFromJSON,
    DeviceResponseFromJSONTyped,
    DeviceResponseToJSON,
} from './DeviceResponse';
import {
    DeviceTypeResponse,
    DeviceTypeResponseFromJSON,
    DeviceTypeResponseFromJSONTyped,
    DeviceTypeResponseToJSON,
} from './DeviceTypeResponse';
import {
    DeviceTypeSettingsResponse,
    DeviceTypeSettingsResponseFromJSON,
    DeviceTypeSettingsResponseFromJSONTyped,
    DeviceTypeSettingsResponseToJSON,
} from './DeviceTypeSettingsResponse';
import {
    ReportForDeviceResponseDeviceGroupHistoryElement,
    ReportForDeviceResponseDeviceGroupHistoryElementFromJSON,
    ReportForDeviceResponseDeviceGroupHistoryElementFromJSONTyped,
    ReportForDeviceResponseDeviceGroupHistoryElementToJSON,
} from './ReportForDeviceResponseDeviceGroupHistoryElement';
import {
    ReportForDeviceResponseDeviceLastConnectionElement,
    ReportForDeviceResponseDeviceLastConnectionElementFromJSON,
    ReportForDeviceResponseDeviceLastConnectionElementFromJSONTyped,
    ReportForDeviceResponseDeviceLastConnectionElementToJSON,
} from './ReportForDeviceResponseDeviceLastConnectionElement';
import {
    ReportForDeviceResponseDeviceStatusVersionElement,
    ReportForDeviceResponseDeviceStatusVersionElementFromJSON,
    ReportForDeviceResponseDeviceStatusVersionElementFromJSONTyped,
    ReportForDeviceResponseDeviceStatusVersionElementToJSON,
} from './ReportForDeviceResponseDeviceStatusVersionElement';
import {
    ReportForDeviceResponseDeviceUpgradeHistoryElement,
    ReportForDeviceResponseDeviceUpgradeHistoryElementFromJSON,
    ReportForDeviceResponseDeviceUpgradeHistoryElementFromJSONTyped,
    ReportForDeviceResponseDeviceUpgradeHistoryElementToJSON,
} from './ReportForDeviceResponseDeviceUpgradeHistoryElement';
import {
    ReportForDeviceResponseStbGroupHistory,
    ReportForDeviceResponseStbGroupHistoryFromJSON,
    ReportForDeviceResponseStbGroupHistoryFromJSONTyped,
    ReportForDeviceResponseStbGroupHistoryToJSON,
} from './ReportForDeviceResponseStbGroupHistory';
import {
    ReportForDeviceResponseUpgradeRuleHistory,
    ReportForDeviceResponseUpgradeRuleHistoryFromJSON,
    ReportForDeviceResponseUpgradeRuleHistoryFromJSONTyped,
    ReportForDeviceResponseUpgradeRuleHistoryToJSON,
} from './ReportForDeviceResponseUpgradeRuleHistory';
import {
    ReportForDeviceVersionHistoryElementResponse,
    ReportForDeviceVersionHistoryElementResponseFromJSON,
    ReportForDeviceVersionHistoryElementResponseFromJSONTyped,
    ReportForDeviceVersionHistoryElementResponseToJSON,
} from './ReportForDeviceVersionHistoryElementResponse';
import {
    UpgradeRuleResponse,
    UpgradeRuleResponseFromJSON,
    UpgradeRuleResponseFromJSONTyped,
    UpgradeRuleResponseToJSON,
} from './UpgradeRuleResponse';

/**
 * 
 * @export
 * @interface ReportForDeviceResponse
 */
export interface ReportForDeviceResponse {
    /**
     * 
     * @type {DeviceResponse}
     * @memberof ReportForDeviceResponse
     */
    device: DeviceResponse;
    /**
     * 
     * @type {ReportForDeviceResponseStbGroupHistory}
     * @memberof ReportForDeviceResponse
     */
    stbGroupHistory: ReportForDeviceResponseStbGroupHistory | null;
    /**
     * 
     * @type {ReportForDeviceResponseUpgradeRuleHistory}
     * @memberof ReportForDeviceResponse
     */
    upgradeRuleHistory: ReportForDeviceResponseUpgradeRuleHistory | null;
    /**
     * 
     * @type {ReportForDeviceResponseDeviceGroupHistoryElement}
     * @memberof ReportForDeviceResponse
     */
    deviceGroupHistoryElement: ReportForDeviceResponseDeviceGroupHistoryElement | null;
    /**
     * 
     * @type {ReportForDeviceResponseDeviceUpgradeHistoryElement}
     * @memberof ReportForDeviceResponse
     */
    deviceUpgradeHistoryElement: ReportForDeviceResponseDeviceUpgradeHistoryElement | null;
    /**
     * 
     * @type {ReportForDeviceResponseDeviceLastConnectionElement}
     * @memberof ReportForDeviceResponse
     */
    deviceLastConnectionElement: ReportForDeviceResponseDeviceLastConnectionElement | null;
    /**
     * 
     * @type {Array<ReportForDeviceVersionHistoryElementResponse>}
     * @memberof ReportForDeviceResponse
     */
    versionHistory: Array<ReportForDeviceVersionHistoryElementResponse> | null;
    /**
     * 
     * @type {DeviceTypeResponse}
     * @memberof ReportForDeviceResponse
     */
    deviceType: DeviceTypeResponse;
    /**
     * 
     * @type {DeviceTypeSettingsResponse}
     * @memberof ReportForDeviceResponse
     */
    deviceTypeSettings: DeviceTypeSettingsResponse;
    /**
     * 
     * @type {UpgradeRuleResponse}
     * @memberof ReportForDeviceResponse
     */
    upgradeRule: UpgradeRuleResponse;
    /**
     * 
     * @type {ReportForDeviceResponseDeviceStatusVersionElement}
     * @memberof ReportForDeviceResponse
     */
    deviceStatusVersionElement: ReportForDeviceResponseDeviceStatusVersionElement | null;
}

export function ReportForDeviceResponseFromJSON(json: any): ReportForDeviceResponse {
    return ReportForDeviceResponseFromJSONTyped(json, false);
}

export function ReportForDeviceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'device': DeviceResponseFromJSON(json['device']),
        'stbGroupHistory': ReportForDeviceResponseStbGroupHistoryFromJSON(json['stbGroupHistory']),
        'upgradeRuleHistory': ReportForDeviceResponseUpgradeRuleHistoryFromJSON(json['upgradeRuleHistory']),
        'deviceGroupHistoryElement': ReportForDeviceResponseDeviceGroupHistoryElementFromJSON(json['deviceGroupHistoryElement']),
        'deviceUpgradeHistoryElement': ReportForDeviceResponseDeviceUpgradeHistoryElementFromJSON(json['deviceUpgradeHistoryElement']),
        'deviceLastConnectionElement': ReportForDeviceResponseDeviceLastConnectionElementFromJSON(json['deviceLastConnectionElement']),
        'versionHistory': (json['versionHistory'] === null ? null : (json['versionHistory'] as Array<any>).map(ReportForDeviceVersionHistoryElementResponseFromJSON)),
        'deviceType': DeviceTypeResponseFromJSON(json['deviceType']),
        'deviceTypeSettings': DeviceTypeSettingsResponseFromJSON(json['deviceTypeSettings']),
        'upgradeRule': UpgradeRuleResponseFromJSON(json['upgradeRule']),
        'deviceStatusVersionElement': ReportForDeviceResponseDeviceStatusVersionElementFromJSON(json['deviceStatusVersionElement']),
    };
}

export function ReportForDeviceResponseToJSON(value?: ReportForDeviceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'device': DeviceResponseToJSON(value.device),
        'stbGroupHistory': ReportForDeviceResponseStbGroupHistoryToJSON(value.stbGroupHistory),
        'upgradeRuleHistory': ReportForDeviceResponseUpgradeRuleHistoryToJSON(value.upgradeRuleHistory),
        'deviceGroupHistoryElement': ReportForDeviceResponseDeviceGroupHistoryElementToJSON(value.deviceGroupHistoryElement),
        'deviceUpgradeHistoryElement': ReportForDeviceResponseDeviceUpgradeHistoryElementToJSON(value.deviceUpgradeHistoryElement),
        'deviceLastConnectionElement': ReportForDeviceResponseDeviceLastConnectionElementToJSON(value.deviceLastConnectionElement),
        'versionHistory': (value.versionHistory === null ? null : (value.versionHistory as Array<any>).map(ReportForDeviceVersionHistoryElementResponseToJSON)),
        'deviceType': DeviceTypeResponseToJSON(value.deviceType),
        'deviceTypeSettings': DeviceTypeSettingsResponseToJSON(value.deviceTypeSettings),
        'upgradeRule': UpgradeRuleResponseToJSON(value.upgradeRule),
        'deviceStatusVersionElement': ReportForDeviceResponseDeviceStatusVersionElementToJSON(value.deviceStatusVersionElement),
    };
}

